import React, { useState, useRef, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import PropTypes from 'prop-types'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import AuthService from '../../services/auth.service'
import { Checkbox } from '@mui/material'
import PreLogin from '../../layout/preLogin'
import { MuiTextField, Loader } from '../../components'
import { ROUTE_SOCIAL_MONITOR } from '../../constants'
import { getRememberUser, rememberMe, removeRememberMe, removeUserDetails, consoleLog } from '../../util'
import { useGlobalStore } from '../../store'
import { LoginButton, LoginContent1, FormControlLabelWrapper, ErrorMsg, PasswordInputWrap, EmailInputWrap } from './style'

const Login = (props) => {
  const form = useRef()
  const { setUser, setCompany, setTheme } = useGlobalStore()

  const [loader, setLoader] = useState(false)
  const [serverErrorMsg, setServerErrorMsg] = useState()
  const navigate = useNavigate()

  const onSubmit = (data, isRemember) => {
    setLoader(true)
    AuthService.loginApi(data)
      .then((resp) => {
        // localStorage.setItem('logssss', JSON.stringify([]))
        if (resp?.user?.UserId) {
          setUser(resp)
          // setCompany(resp.OrganizationUsers)
          setCompany(resp.company)
          navigate(ROUTE_SOCIAL_MONITOR)
        } else {
          setServerErrorMsg('Invalid Credentials')
        }
        if (isRemember) {
          rememberMe(data)
        } else {
          removeRememberMe()
        }
      })
      .catch((error) => {
        consoleLog('ERROR : ', error)
      }).finally(() => {
        setLoader(false)
      })
  }

  const validation = (values) => {
    const errors = {}
    if (!values.password) {
      errors.password = 'Password is required'
    }
    return errors
  }

  const isLocal = window.location.host.indexOf('localhost') !== -1
  // URL1 = // http://engagementterminal.mavenmagnet.com/EngagementTerminal/AdminSocialMonitor.aspx
  // URL2 = // http://engagementterminal.mavenmagnet.com/EngagementTerminal/AdminManageQuestions.aspx
  // URL3 = // http://engagementterminal.mavenmagnet.com/EngagementTerminal/AdminVerbatim.aspx

  const dummyCreds = [
    { email: 'designanalyst1@mmtest.com', password: 'design1' },
    { email: 'designanalyst2@mmtest.com', password: 'design2' },
    { email: 'devuitester@mmtest.com', password: 'devuitester' } // ITCCDF052024ZA
    // { email: 'ITCCDFQ32024ZA', password: '' }
  ]

  const formik = useFormik({
    validateOnChange: false,
    validateOnBlur: false,
    initialValues: {
      email: isLocal ? dummyCreds[0].email : '',
      password: isLocal ? dummyCreds[0].password : '',
      rememberMe: false
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .max(45)
        .required('Email is required'),
      password: Yup.string().max(45).required('Password is required')
    }),
    validate: (values) => validation(values),
    onSubmit: (values) => {
      const updatedValues = { ...values }
      const isRemember = updatedValues.rememberMe
      delete updatedValues.removeRememberMe
      onSubmit(updatedValues, isRemember)
    }
  })

  useEffect(() => {
    removeUserDetails()
    const rememberData = getRememberUser()
    if (rememberData?.userName && rememberData?.password) {
      formik.setValues({
        email: rememberData.userName,
        password: rememberData.password,
        rememberMe: true
      })
    }
  }, [])

  useEffect(() => {
    setTheme('light')
    localStorage.clear()
    localStorage.removeItem('theme')
    // localStorage.setItem('logssss', JSON.stringify([]))
    localStorage.setItem('company', JSON.stringify({}))
    localStorage.setItem('user', JSON.stringify({}))
  }, [])

  return (
    <PreLogin>
      <form onSubmit={formik.handleSubmit} ref={form} autoComplete='off'>
          <EmailInputWrap>
            <MuiTextField
              error={Boolean(
                formik.touched.email && formik.errors.email
              )}
              fullWidth
              helperText={formik.touched.email && formik.errors.email}
              name='email'
              label='Email'
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              type='text'
              value={formik.values.email || ''}
              variant='standard'
              sx={{
                '& input': {
                  fontSize: '16px !important'
                }
              }}
            />
          </EmailInputWrap >

          <PasswordInputWrap>
            <MuiTextField
              error={Boolean(
                formik.touched.password && formik.errors.password
              )}
              fullWidth
              helperText={formik.touched.password && formik.errors.password}
              name='password'
              label='Password'
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              type='password'
              value={formik.values.password || ''}
              variant='standard'
            />
          </PasswordInputWrap>
          {serverErrorMsg && <ErrorMsg>{serverErrorMsg}</ErrorMsg>}

          <LoginContent1>
            <FormControlLabelWrapper name='rememberMe' checked={formik.values.rememberMe} onChange={formik.handleChange} control={<Checkbox />} label='Remember me' size='medium' />
          </LoginContent1>

          <LoginButton
            variant='contained'
            color='secondary'
            type='submit'
            onClick={formik.handleSubmit}
            disabled={loader}
            endIcon={loader && <Loader />}
          >
            Sign In
          </LoginButton>
      </form>
    </PreLogin>
  )
}

Login.propTypes = {
  history: PropTypes.func
}

export default Login
